<template>
  <div>
      <div class="input-group mb-0">
        <input
          class="form-control search"
          type="text"
          v-model="myKeyword"
          @keyup="handleEnterKey"
          placeholder="Search for products" />
        <div class="input-group-append">
          <button
            class="btn btn-danger px-4 py-0"
            @click="goToSearchPage" type="button">
            <img src="/images/search.svg" width="16" />
          </button>
        </div>
      </div>

    <div class="row pt-2" style="height: 30px">
      <div class="col text-center">
        <a href="/new-products" class="featured">New</a>
      </div>
      <div class="col text-center">
        <a href="/category/13/smartphones" class="featured">Smartphones</a>
      </div>
      <div class="col text-center">
        <a href="/category/1/air-fryers" class="featured">Air Fryers</a>
      </div>
      <div class="col text-center search-item-4">
        <a class="featured" href="/search/blenders">Blenders</a>
      </div>
      <div class="col text-center search-item-5">
        <a class="featured" href="/category/19/skincare">Skincare</a>
      </div>
      <div class="col text-center search-item-6">
        <a class="featured" href="/search/notebooks">Laptops</a>
      </div>
      <div class="col text-center search-item-7">
        <a class="featured" href="/search/headphones">Headphones</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["keyword"],
  data() {
    return {
      myKeyword: null,
    };
  },

  created() {
    if (this.keyword) this.myKeyword = this.keyword.toLowerCase();
  },

  methods: {
    handleEnterKey(event) {
      if (event.keyCode === 13) {
        this.goToSearchPage();
      }
    },

    goToSearchPage() {
      if (this.myKeyword) {
        window.location.href = `/search/${this.myKeyword}`;
      }
    },
  },
};
</script>
